import { DsIcon } from '@descomplica/design-system-react';
import React from 'react';

import { Redirect, RedirectParams } from './redirect';

export const RedirectContainer: React.FC<RedirectParams> = ({
  className,
  ...params
}: RedirectParams) => {
  const fullClassname = ['redirect', className].join(' ').trim();

  const routeChange = () => {
    location.href = params.href;
  };

  return (
    <div className="redirect-container" onClick={routeChange}>
      <Redirect className={fullClassname} {...params} />
      <DsIcon image="arrow-forward" />
    </div>
  );
};
